module.exports = __webpack_public_path__ + "c4f5215c046c775e0b3e4f5d1a339751.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/body/heart-skirt.png
// module id = 1855
// module chunks = 0